import React from "react"

import BrandSection from "./brand_section"
import CtaCard from "./cta_card"

const STYLES = {
  footer: "flex w-full flex-col items-center gap-6 bg-neutral-900 px-5 pt-8 pb-[136px] text-center",
  ctaContainer: "flex flex-col items-center",
} as const

const VenueFooterMobile: React.FC = () => (
  <footer className={STYLES.footer} data-testid="public-venue-footer">
    <BrandSection align="center" />
    <div className={STYLES.ctaContainer}>
      <CtaCard variant="mobile" />
    </div>
  </footer>
)

export default VenueFooterMobile
